module.exports = __webpack_public_path__ + "static/media/menuQueue.01f426b9.svg";